import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetSelected } from "../../../ducks/catalog/catalog";
import { getAnySelected } from "../../../ducks/catalog/selectors";

export const useSelectedResetEffect = <Dependency>(dependency: Dependency) => {
  const selected = useSelector(getAnySelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selected) {
      dispatch(resetSelected());
    }
  }, [dependency]);
};
